(() => {
  if (customElements.get('volume-upsells')) {
    return;
  }

  class VolumeUpsells extends HTMLElement {
    productForm = null;
    countElements = null;
    productInputs = [];
    tierLimit = 0;
    
    constructor() {
      super();
      this.actionClasses = {
        locked: 'is-locked',
        limitReached: 'has-reached-limit',
      };
    }

    showTierProducts(quantity) {
      const currentTier = quantity - 1;
      this.tierLimit = Number(this.getAttribute(`data-tier-${currentTier}-limit`));
      this.classList.remove(this.actionClasses.locked);

      const subheading = this.querySelector(`[data-tier-${currentTier}-subheading]`);
      const selectedText = this.querySelector(`[data-tier-${currentTier}-selected-text]`);
      
      subheading?.classList?.remove('hidden');
      selectedText?.classList?.remove('hidden');

      for (const tier of [1, 2]) {
        const prices = this.querySelectorAll(`[data-tier-${tier}-price]`);
        prices.forEach(price => price.classList.toggle('hidden', tier !== currentTier));
      }

      for (const tier of [1, 2]) {
        const badges = this.querySelectorAll(`[data-tier-${tier}-badge]`);
        badges.forEach(badge => badge.classList.toggle('hidden', tier !== currentTier));
      }
    }

    reset() {
      this.tierLimit = 0;
      this.classList.add(this.actionClasses.locked);
      this.classList.remove(this.actionClasses.limitReached);

      for (const tier of [1, 2]) {
        const subheading = this.querySelector(`[data-tier-${tier}-subheading]`);
        const selectedText = this.querySelector(`[data-tier-${tier}-selected-text]`);
        const prices = this.querySelectorAll(`[data-tier-${tier}-price]`);
        const badges = this.querySelectorAll(`[data-tier-${tier}-badge]`);

        subheading?.classList?.add('hidden');
        selectedText?.classList?.add('hidden');
        prices.forEach(price => price.classList.toggle('hidden', tier === 2));
        badges.forEach(badge => badge.classList.toggle('hidden', tier === 2));
      }

      this.countElements.forEach(el => el.textContent = '0');
      this.productInputs.forEach(input => input.checked = false);
    }

    updateClones(target) {
      if (target.name.includes('-cloned')) {
        const originalName = target.name.replace('-cloned', '');
        const originalInput = this.querySelector(`input[name="${originalName}"]`);
        originalInput.checked = target.checked;
        originalInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const cloneName = `${target.name}-cloned`;
      const cloneInput = this.querySelector(`input[name="${cloneName}"]`);
      if (cloneInput) {
        cloneInput.checked = target.checked;
      }
    }

    onProductSelect(event) {
      const target = event.target;
      // Handle cloned inputs
      this.updateClones(target);
      if (target.name.includes('-cloned')) {
        return;
      }
      const currentSelections = this.querySelectorAll('[data-volume-upsell-product]:checked').length;

      this.countElements.forEach(el => el.textContent = currentSelections.toString());
      this.classList.toggle(this.actionClasses.limitReached, currentSelections == this.tierLimit);
    }

    onQuantityChange(event) {
      if (event.target.name !== 'quantity') return;

      const quantity = Number(this.productForm.elements['quantity'].value);

      this.reset();
      if (quantity < 2) {
        return;
      }

      this.showTierProducts(quantity);
    }
    
    connectedCallback() {
      this.productForm = this.closest('product-form')?.querySelector('form');

      if (!this.productForm) {
        return;
      }
      this.countElements = this.querySelectorAll('[data-selected-count]');
      this.productInputs = this.querySelectorAll('[data-volume-upsell-input]');

      this.handleQuantityChange = this.onQuantityChange.bind(this);
      this.handleProductSelect = this.onProductSelect.bind(this);
      this.productForm.addEventListener('change', this.handleQuantityChange);
      this.productInputs.forEach(input => {
        input.addEventListener('change', this.handleProductSelect);
      });
    }

    disconnectedCallback() {
      this.productForm.removeEventListener('change', this.handleQuantityChange);
      this.productInputs.forEach(input => {
        input.removeEventListener('change', this.handleProductSelect);
      });
    }
  }

  customElements.define('volume-upsells', VolumeUpsells);
})();